module.exports = __webpack_public_path__ + "img/navbarbg.0efb6173.png";